import { motion, useScroll } from "framer-motion";
import { Download, X } from "lucide-react";
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";

interface StickyCTABarProps {
  className?: string;
}

export const StickyCTABar = ({ className = "" }: StickyCTABarProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const { scrollY } = useScroll();

  useEffect(() => {
    return scrollY.on("change", (latest) => {
      // Zeige Bar nach 50% Scroll
      const shouldShow = latest > window.innerHeight * 0.5;
      setIsVisible(shouldShow);
    });
  }, [scrollY]);

  const scrollToForm = () => {
    document.getElementById("lead-form")?.scrollIntoView({ 
      behavior: "smooth", 
      block: "start" 
    });
    
    // Nach 600ms: Submit-Button hervorheben
    setTimeout(() => {
      const submitBtn = document.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.classList.add('animate-pulse', 'ring-2', 'ring-accent');
        setTimeout(() => {
          submitBtn.classList.remove('animate-pulse', 'ring-2', 'ring-accent');
        }, 2000);
      }
    }, 600);
  };

  if (!isVisible || !isExpanded) {
    return (
      <motion.button
        initial={{ y: 100 }}
        animate={{ y: isVisible && !isExpanded ? 0 : 100 }}
        className={`fixed bottom-6 right-6 z-50 bg-accent text-accent-foreground px-6 py-3 rounded-full shadow-lg hover:shadow-xl transition-shadow font-semibold flex items-center gap-2 ${className}`}
        onClick={scrollToForm}
      >
        <Download className="w-5 h-5" />
        Checkliste anfordern
      </motion.button>
    );
  }

  return (
    <motion.div
      initial={{ y: 100 }}
      animate={{ y: isVisible ? 0 : 100 }}
      transition={{ type: "spring", damping: 20 }}
      className={`fixed bottom-0 left-0 right-0 z-50 bg-card/95 backdrop-blur-lg border-t border-border shadow-2xl ${className}`}
    >
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-4">
          <div className="flex-1 text-center sm:text-left">
            <p className="font-bold text-sm sm:text-base">🔒 Checkliste jetzt kostenlos sichern</p>
            <p className="text-xs text-muted-foreground">500+ Praxen vertrauen uns bereits</p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
            <Button 
              onClick={scrollToForm}
              size="lg"
              variant="outline"
              className="font-semibold"
            >
              <Download className="mr-2 w-5 h-5" />
              Zum Download-Formular
            </Button>
            
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsExpanded(false)}
              className="absolute top-2 right-2 sm:static"
            >
              <X className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
